import { create } from 'zustand';

interface FlowInteractionState {
  isDrawerSuppressed: boolean;
  isDraggingSelection: boolean;
  isDraggingNode: boolean;
  isMarqueeSelecting: boolean;
  // true while the user is dragging a node from the left palette/menu onto the canvas (HTML5 drag).
  isDraggingFromPalette: boolean;

  setIsDrawerSuppressed: (value: boolean) => void;
  setIsDraggingSelection: (value: boolean) => void;
  setIsDraggingNode: (value: boolean) => void;
  setIsMarqueeSelecting: (value: boolean) => void;
  setIsDraggingFromPalette: (value: boolean) => void;
  reset: () => void;
}

const initialState: Pick<
  FlowInteractionState,
  'isDrawerSuppressed' | 'isDraggingSelection' | 'isDraggingNode' | 'isMarqueeSelecting' | 'isDraggingFromPalette'
> = {
  isDrawerSuppressed: false,
  isDraggingSelection: false,
  isDraggingNode: false,
  isMarqueeSelecting: false,
  isDraggingFromPalette: false,
};

export const useFlowInteractionStore = create<FlowInteractionState>((set) => ({
  ...initialState,

  setIsDrawerSuppressed: (value) => set({ isDrawerSuppressed: value }),
  setIsDraggingSelection: (value) => set({ isDraggingSelection: value }),
  setIsDraggingNode: (value) => set({ isDraggingNode: value }),
  setIsMarqueeSelecting: (value) => set({ isMarqueeSelecting: value }),
  setIsDraggingFromPalette: (value) => set({ isDraggingFromPalette: value }),
  reset: () => set(initialState),
}));
